var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallheaderblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.708,
    height: 32.709,
    viewBox: "0 0 32.708 32.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3169",
    "data-name": "Group 3169",
    transform: "translate(0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3168",
    "data-name": "Group 3168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4797",
    "data-name": "Path 4797",
    d: "M24.873,64.635a2.292,2.292,0,0,0-3.465,0c-.81.8-1.62,1.606-2.416,2.423a.477.477,0,0,1-.667.123c-.524-.286-1.082-.517-1.586-.83a25.128,25.128,0,0,1-6.058-5.513A14.352,14.352,0,0,1,8.51,57.359a.5.5,0,0,1,.123-.64c.81-.783,1.6-1.586,2.4-2.389a2.3,2.3,0,0,0-.007-3.546c-.633-.64-1.266-1.266-1.9-1.906-.653-.653-1.3-1.314-1.96-1.96a2.306,2.306,0,0,0-3.465.007c-.817.8-1.6,1.627-2.43,2.416A3.944,3.944,0,0,0,.029,52,11.276,11.276,0,0,0,.9,56.855a29.49,29.49,0,0,0,5.234,8.719,32.39,32.39,0,0,0,10.727,8.392A15.514,15.514,0,0,0,22.8,75.7a4.355,4.355,0,0,0,3.737-1.423c.694-.776,1.477-1.484,2.212-2.226a2.316,2.316,0,0,0,.014-3.526Q26.827,66.571,24.873,64.635Z",
    transform: "translate(-0.006 -42.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4798",
    "data-name": "Path 4798",
    d: "M245.232,105.679l2.512-.429A11.274,11.274,0,0,0,238.208,96l-.354,2.525a8.713,8.713,0,0,1,7.378,7.154Z",
    transform: "translate(-221.665 -89.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4799",
    "data-name": "Path 4799",
    d: "M253.726,5.3A18.52,18.52,0,0,0,243.108,0l-.354,2.525a16.16,16.16,0,0,1,13.674,13.252l2.512-.429A18.655,18.655,0,0,0,253.726,5.3Z",
    transform: "translate(-226.231)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallheaderblack);
export default __webpack_public_path__ + "static/media/callheaderblack.d6ba66651c74e16a00acc3eea95b8006.svg";
export { ForwardRef as ReactComponent };